













import { Component, Prop, Vue } from 'vue-property-decorator';
import {curPref} from "@/services/Preferences";

@Component
export default class NavBarRouter extends Vue {
  
  @Prop({ default: [],  type: Array}) items!:Item[];
  @Prop({type:String}) prefKey:string|undefined;
  @Prop({default: '',type:String}) basePath!:string;

  updatePrefrence(newSection:string){
    if (this.prefKey){
      curPref.store(this.prefKey, newSection);
    }
  }

}

export interface Item {
  path:string,
  label:string
}
